import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpModule } from '@angular/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TagInputModule } from 'ngx-chips';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AgmCoreModule } from '@agm/core';
import { DataTableModule } from 'angular2-datatable';
import { NgPipesModule } from 'ngx-pipes';
import { AngularFireModule } from 'angularfire2';
import { AngularFirestoreModule, AngularFirestore } from 'angularfire2/firestore';
import { AngularFireAuthModule } from 'angularfire2/auth';
import { AngularFireDatabaseModule } from 'angularfire2/database';




import { AppComponent } from './app.component';
import { HeaderComponent } from './header/header.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { HaulersComponent } from './haulers/haulers.component';
import { HaulersListComponent } from './haulers/haulers-list/haulers-list.component';
import { HaulersMapComponent } from './haulers/haulers-map/haulers-map.component';
import { HaulersEditComponent } from './haulers/haulers-edit/haulers-edit.component';
import { AppRoutingModule } from './app-routing.module';
import { environment } from '../environments/environment';
import { DropdownDirective } from './shared/dropdown.directive';
import { HaulersService } from './haulers/haulers.service';
import { SigninComponent } from './auth/signin/signin.component';
import { AuthService } from './auth/auth.service';
import { AuthGuard } from './auth/auth-guard.service';
import { HaulersQueryComponent } from './haulers/haulers-query/haulers-query.component';
import { QueryService } from './haulers/query.service';
import { FilterByWastesPipe } from './haulers/filters/filter-by-wastes.pipe';
import { FilterByServicesPipe } from './haulers/filters/filter-by-services.pipe';
import { HaulersViewComponent } from './haulers/haulers-view/haulers-view.component';
import { GeoService } from './shared/geo.service';




@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    SidebarComponent,
    HaulersComponent,
    HaulersListComponent,
    HaulersMapComponent,
    HaulersEditComponent,
    DropdownDirective,
    SigninComponent,
    HaulersQueryComponent,
    FilterByWastesPipe,
    FilterByServicesPipe,
    HaulersViewComponent
  ],
  imports: [
    AngularFireModule.initializeApp(environment.firebase),
    AngularFirestoreModule,
    AngularFireDatabaseModule,
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    HttpModule ,
    DataTableModule,
    NgPipesModule,
    ReactiveFormsModule,
    TagInputModule,
    BrowserAnimationsModule,
    AgmCoreModule.forRoot({
      apiKey: environment.googleMapsKey
    })
  ],
  providers: [HaulersService, AuthService, AuthGuard, QueryService, GeoService],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// /Users/julien/code/urbyn/urbyn-backoffice/src/app/app.module.ts